import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DocumentReader } from 'src/app/modules/core/store/models';

@Component({
    selector: 'app-color-cell',
    templateUrl: './color-cell.component.html',
    styleUrls: ['./color-cell.component.scss'],
    standalone: false
})
export class ColorCellComponent implements OnInit {
  value: any;

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {}

  agInit(params: any): void {
    const document = params.data;
    const field = params.schemaField;
    const reader = new DocumentReader(document);
    this.value = !!params.data ? reader.getFieldValue(field.systemName) : params.value;
  }
}
